import { render } from "./GridPenerimaanDetail.vue?vue&type=template&id=a8811dc2"
import script from "./GridPenerimaanDetail.vue?vue&type=script&lang=js"
export * from "./GridPenerimaanDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__